import React, { useState } from "react"
import { Row, Col, Button } from "antd"
import "./ContactUs.scoped.scss"
import { apiClient } from "../../../../api"
import { token } from '../../../../config'
import ModalSuccess from "../../../../components/Ants/Modal/ModalSuccess"
import ModalErrorWarning from "../../../../components/Ants/Modal/ModalErrorWaring"
import ModalError from "../../../../components/Ants/Modal/ModalError"

const ContactUs = () => {
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    message: ""
  })
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [responseSuccess, setResponseSuccess] = useState(false)
  const [responseError, setResponseError] = useState(false)
  const [responseMessage, setResponseMessage] = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
    setErrors((prev) => ({ ...prev, [name]: "" })) // clear error when typing
  }

  const isValidEmail = (email) => {
    // Regex พื้นฐานตรวจสอบ email
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const isValidPhone = (phone) => {
    return /^\d{9,10}$/.test(phone)
  }

  const validate = () => {
    const newErrors = {}
    if (!formValues.firstName.trim()) newErrors.firstName = "Please input your first name!"
    if (!formValues.mobile.trim()) {
      newErrors.mobile = "Please input your phone number!"
    } else if (!isValidPhone(formValues.mobile.trim())) {
      newErrors.mobile = "Phone number must be 9 or 10 digits!"
    }

    if (!formValues.email.trim()) {
      newErrors.email = "Please input your email!"
    } else if (!isValidEmail(formValues.email.trim())) {
      newErrors.email = "Invalid email format!"
    }
    return newErrors
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const validationErrors = validate()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }
    setLoading(true)

    const req = {
      "firstName": formValues.firstName,
      "lastName": formValues.lastName,
      "mobile": formValues.mobile,
      "email": formValues.email,
      "message": formValues.message
    }

    await apiClient.post("api/ecom/contact-us", req, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        if (response.data.Data === "failed") {
          setResponseError(true)
          setResponseMessage(response.data.Message)
        } else {
          setResponseSuccess(true)
          setResponseMessage(response.data.Message)
        }

      })
      .catch((error) => {
        console.log("error", error)
        setResponseError(true)
        setResponseMessage("ข้อผิดพลาดกรุณาลองใหม่อีกครั้ง")
      })
      .finally(() => {
        setLoading(false)
        setFormValues({ firstName: "", lastName: "", mobile: "", email: "", message: "" })
      })

  }

  return (
    <div className="contact-container">
      <div className="contact-card">
        <Row className="contact-row">
          <Col xs={24} lg={10} className="contact-left">
            <div className="contact-content">
              <h1 className="contact-title">
                Contact us <span className="arrow">»</span>
                <br />
                for make you
                <br />
                owner package
              </h1>
              <p className="contact-description">
                Our team is here to help you with make plan to suit your needs.
              </p>
            </div>
          </Col>

          <Col xs={24} lg={14} className="contact-right">
            <form className="contact-form" onSubmit={handleSubmit}>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div className="form-item">
                    <label>
                      First name <span className="required">*</span>
                    </label>
                    <input
                      name="firstName"
                      value={formValues.firstName}
                      onChange={handleChange}
                      placeholder="First name"
                      className="form-input"
                      autoComplete="off"
                    />
                    {errors.firstName && <div className="error-text">{errors.firstName}</div>}
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div className="form-item">
                    <label>Last name</label>
                    <input
                      name="lastName"
                      value={formValues.lastName}
                      onChange={handleChange}
                      placeholder="Last name"
                      autoComplete="off"
                      className="form-input"
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <div className="form-item">
                    <label>
                      Mobile phone number <span className="required">*</span>
                    </label>
                    <input
                      name="mobile"
                      value={formValues.mobile}
                      onChange={handleChange}
                      placeholder="Mobile phone number"
                      className="form-input"
                      autoComplete="off"
                    />
                    {errors.mobile && <div className="error-text">{errors.mobile}</div>}
                  </div>
                </Col>

                <Col xs={24} md={12}>
                  <div className="form-item">
                    <label>
                      Email <span className="required">*</span>
                    </label>
                    <input
                      name="email"
                      type="text"
                      value={formValues.email}
                      onChange={handleChange}
                      placeholder="Email"
                      className="form-input"
                    />
                    {errors.email && <div className="error-text">{errors.email}</div>}
                  </div>
                </Col>
              </Row>

              <div className="form-item">
                <label>Message (Optional)</label>
                <textarea
                  name="message"
                  value={formValues.message}
                  onChange={handleChange}
                  placeholder="Type your message here..."
                  className="form-textarea"
                  rows={4}
                />
              </div>

              <div className="form-item">
                <Button type="primary" htmlType="submit" className="submit-button" size="large" disabled={loading}>
                  Submit
                </Button>
              </div>
            </form>
          </Col>
        </Row>
      </div>
      <ModalSuccess
        loading={loading}
        successModalVisible={responseSuccess}
        successModal={setResponseSuccess}
        messageSuccess={responseMessage}
      />
      <ModalError
        loading={loading}
        errorModalVisible={responseError}
        errorModal={setResponseError}
        messageError={responseMessage}
      />
    </div>
  )
}

export default ContactUs
